import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ userCard }: RootState) => userCard;

export const selectUserCard = createSelector(
    selectRoot,
    ({ userCard }) => userCard,
);
